import { useEffect, useState } from "react";
import { collection, onSnapshot, query, orderBy } from "firebase/firestore";
import { db } from "../../firebase";

export function useDrivers(id) {
  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;

    const colName =
      process.env.REACT_APP_COL_USERS_ORDERS ?? "COL_USERS_ORDERS";
    const driversRef = collection(db, colName, id, "drivers");
    const q = query(driversRef, orderBy("createdAt", "desc"));

    const unsub = onSnapshot(
      q,
      (snap) => {
        const list = snap.docs.map((d) => {
          const data = d.data();
          return {
            id: d.id,
            ...data,
            // normalizamos createdAt a Date (si existe)
            createdAtDate: data?.createdAt?.toDate
              ? data.createdAt.toDate()
              : data?.createdAt?.seconds
              ? new Date(data.createdAt.seconds * 1000)
              : null,
          };
        });
        setDrivers(list);
        setLoading(false);
      },
      (err) => {
        console.error("Error drivers:", err);
        setLoading(false);
      }
    );

    return () => unsub();
  }, [id]);

  return { drivers, loading };
}
